module.exports = __webpack_public_path__ + "img/chat_close_icon.08d26456.svg";